import React from 'react';

import { Toggle, useToast } from '@dutchie/backoffice-ui-library';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import {
  SearchLspBrandsDocument,
  useUpdateLspBrandSettingsMutation,
} from 'src/apps/brand-connect/api/generated/graphql';

import { BrandRow } from '../../shared/types';
import { useDataShareBulkUpdateLoading } from '../context/data-share-update-loading-context';

export const ConnectionStatusCell = (
  params: GridRenderCellParams<BrandRow, boolean>,
) => {
  const { dataSharingBulkUpdateLoading } = useDataShareBulkUpdateLoading();

  const [updateLspBrandSettings, { loading: updateLspBrandSettingsLoading }] =
    useUpdateLspBrandSettingsMutation({
      refetchQueries: [SearchLspBrandsDocument],
      awaitRefetchQueries: true,
    });

  const disableToggle =
    dataSharingBulkUpdateLoading || updateLspBrandSettingsLoading;

  const { showSuccess, showError } = useToast();

  const handleToggle = async () => {
    try {
      await updateLspBrandSettings({
        variables: {
          brandId: String(params.id),
          settings: {
            dataSharingEnabled: !params.value,
          },
        },
      });
      showSuccess({
        message: `Data sharing status successfully changed for ${params.row.name}.`,
      });
    } catch (error) {
      console.error(error);
      showError({
        message: `Failed to update data sharing status for ${params.row.name}.`,
      });
    }
  };

  return (
    <div>
      <Toggle
        checked={Boolean(params.value)}
        disabled={disableToggle}
        disabledText="Inactive"
        enabledText="Active"
        onClick={handleToggle}
        showCheckmark
      />
    </div>
  );
};
